export default class DeletePostUseCase {
  constructor(postRepository) {
    this.postRepository = postRepository;
  }

  async execute(postId, userId) {
    if (!postId) {
      throw new Error('Post ID is required');
    }

    if (!userId) {
      throw new Error('User ID is required');
    }

    try {
      return await this.postRepository.deletePost(postId, userId);
    } catch (error) {
      throw error;
    }
  }
} 